import React from 'react';
import { Segment } from 'semantic-ui-react';
import ExamHeader from '../Header';
import QuestionPage from '../Page';
import ExamFooter from '../Footer';
import ExamSummary from '../../ExamSummary';
import ExamStats from '../ExamStats';
import { Styles } from '../../../../res';
import QuestionsNav from '../Nav/QuestionsNav';

const { noExtraSpaces } = Styles;

const DefaultLayout = (props) => {
    const {
        selectedCourse, selectedCourseStruct, Qindex, Q, user, questions, onGoingExam,
        userOnFinishExam, examFinishingLoading, showExamSummary, setShowExamSummary,
        userExamSelectQuestion, handleQuestionFilterChange, questionsFilter, FactIndex,
        questionOptionsLoading, questionOptionsError, userExamFlagQuestion, userExamFavQuestion,
        userExamAnswerQuestion, userExamHideSomeAnswers, userExamExcludeOption, userExamHighlightText,
    } = props;

    return (
        <div className='tw-flex tw-flex-col tw-min-h-screen tw-relative'>

            <ExamHeader
                course={selectedCourse}
                courseStruct={selectedCourseStruct.courseStruct}
                Qindex={Qindex}
                Q={Q}
                user={user}
                questions={questions}
                onGoingExam={onGoingExam}
                onFlagQuestion={onGoingExam.isViewOnly ? () => { } : userExamFlagQuestion}
                onFavQuestion={onGoingExam.isViewOnly ? () => { } : userExamFavQuestion}
                userOnFinishExam={userOnFinishExam}
                examFinishingLoading={examFinishingLoading}
                isMockExam={onGoingExam.isMockExam}
                summary={{ show: showExamSummary, setShowSummary: setShowExamSummary }}
                theme={onGoingExam.theme}
                isViewOnly={onGoingExam.isViewOnly}
                onSelectQuestion={userExamSelectQuestion}
            />

            <Segment basic style={{ ...noExtraSpaces, height: '100%' }}>
                {showExamSummary ?
                    <ExamSummary
                        course={selectedCourse}
                        questions={questions}
                        onSelectQuestion={userExamSelectQuestion}
                        onFlagQuestion={onGoingExam.isViewOnly ? () => { } : userExamFlagQuestion}
                        onFavQuestion={onGoingExam.isViewOnly ? () => { } : userExamFavQuestion}
                        summary={{ show: showExamSummary, setShowSummary: setShowExamSummary }}
                        isMockExam={onGoingExam.isMockExam}
                        isViewOnly={onGoingExam.isViewOnly}
                        theme={onGoingExam.theme}
                        setQuestionsFilter={handleQuestionFilterChange}
                        questionsFilter={questionsFilter}
                    />
                    : <QuestionPage
                        course={selectedCourse}
                        Q={Q}
                        Qindex={Qindex}
                        FactIndex={FactIndex}
                        onAnswerQuestion={onGoingExam.isViewOnly ? () => { } : userExamAnswerQuestion}
                        loading={questionOptionsLoading}
                        error={questionOptionsError}
                        isMockExam={onGoingExam.isMockExam}
                        isViewOnly={onGoingExam.isViewOnly}
                        theme={onGoingExam.theme}
                        user={user}
                        questions={questions}
                        onGoingExam={onGoingExam}
                        onSelectQuestion={userExamSelectQuestion}
                        onFlagQuestion={onGoingExam.isViewOnly ? () => { } : userExamFlagQuestion}
                        onFavQuestion={onGoingExam.isViewOnly ? () => { } : userExamFavQuestion}
                        onHideSomeAnswers={onGoingExam.isViewOnly ? () => { } : userExamHideSomeAnswers}
                        onExcludeOption={onGoingExam.isViewOnly ? () => { } : userExamExcludeOption}
                        userExamHighlightText={onGoingExam.isViewOnly ? () => { } : userExamHighlightText}
                    />
                }
            </Segment >

            <ExamFooter
                Q={Q}
                questions={questions}
                onSelectQuestion={userExamSelectQuestion}
                onFlagQuestion={onGoingExam.isViewOnly ? () => { } : userExamFlagQuestion}
                onFavQuestion={onGoingExam.isViewOnly ? () => { } : userExamFavQuestion}
                isMockExam={onGoingExam.isMockExam}
                isViewOnly={onGoingExam.isViewOnly}
                Qindex={Qindex}
                summary={{ show: showExamSummary, setShowSummary: setShowExamSummary }}
                userOnFinishExam={userOnFinishExam}
                examFinishingLoading={examFinishingLoading}
                onGoingExam={onGoingExam}
                theme={onGoingExam.theme}
                setQuestionsFilter={handleQuestionFilterChange}
                questionsFilter={questionsFilter}
            />

            <ExamStats
                // showNavStats
                questions={questions}
            />

            <QuestionsNav
                Q={Q}
                questions={questions}
                Qindex={Qindex}
                onSelectQuestion={userExamSelectQuestion}
                isViewOnly={onGoingExam.isViewOnly}
                showNavList={false}
            />

        </div >
    );
};

export default DefaultLayout;